module.exports = __webpack_public_path__ + "img/service.ac29c3b8.jpg";